<template>
    <div>
        <ol class="step-indicator">
            <router-link tag="li" :to="{ name: 'SearchNote' }">
            <!--<li>-->
                <div class="step"><b>1</b></div>
                <div class="caption hidden-xs hidden-sm"><b>Buscar Nota</b></div>
            <!--</li>-->
            </router-link>
            <router-link tag="li" :to="{ name: 'SearchClient' }" class="">
            <!--<li>-->
                <div class="step"><b>2</b></div>
                <div class="caption hidden-xs hidden-sm"><b>Datos de Cliente</b></div>
            <!--</li>-->
            </router-link>
            <router-link tag="li" :to="{ name: 'CreateInvoice' }">
            <!--<li>-->
                <div class="step"><b>3</b></div>
                <div class="caption hidden-xs hidden-sm"><b>Facturar</b></div>
            <!--</li>-->

            </router-link>
        </ol>
        <div class="tab-content">
            <div class="card">
                <div class="card-body p-md-5">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Steps',
    }
</script>
<style scoped>
    .step-indicator {
        border-collapse: separate;
        display: table;
        margin-left: 0px;
        position: relative;
        table-layout: fixed;
        text-align: center;
        vertical-align: middle;
        padding-left: 0;
        padding-top: 20px;
    }

    .step-indicator li {
        display: table-cell;
        position: relative;
        float: none;
        padding: 0;
        width: 1%;
    }

    .step-indicator li:after {
        left: 50%;
    }

    .step-indicator li:after {
        background-color: #ccc;
        content: "";
        display: block;
        height: 1px;
        position: absolute;
        width: 100%;
        top: 32px;
    }

    .step-indicator li:last-child:after {
        display: none;
    }

    .step-indicator li.active .step {
        background-color: #28a745;
        border-color: #28a745;
        color: #fff;
    }

    .step-indicator li.active .caption {
        color: #000;
    }

    .step-indicator .step {
        background-color: #fff;
        border-radius: 50%;
        border: 1px solid #ccc;
        color: #ccc;
        font-size: 24px;
        height: 64px;
        line-height: 64px;
        margin: 0 auto;
        position: relative;
        width: 64px;
        z-index: 1;
    }

    .step-indicator .step:hover {
        cursor: pointer;
    }

    .step-indicator .caption {
        color: #ccc;
        padding: 11px 16px;
    }

</style>